export default __webpack_public_path__ + "static/media/PS-background.103d1a2a.svg";